import * as React from 'react';

/**
 * Currently, setting FluentUI Callout property shouldDismissOnWindowFocus=true,
 * does not fully fix light dismiss for FluentUi popup(callout) menus and variants,
 * specifically when focus goes to fluid iframe (component area)
 *
 * Use this custom hook to light dismiss FluentUI popup menus in scenarios where
 * setting focus in an component area leaves the menu open.
 *
 * @param dismissMenu callback to dismiss fluent ui Popup menus
 */
export const lightDismissMenuOnWindowBlur = (dismissMenu: () => void) => {
  // TODO: review for violation of rules of hooks (hooks must be called in React function component or custom hook)
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const menuVisibilityRef = React.useRef<boolean>(false);

  // TODO: review for violation of rules of hooks (hooks must be called in React function component or custom hook)
  // eslint-disable-next-line react-hooks/rules-of-hooks
  React.useEffect(() => {
    const windowBlurListener = (event: FocusEvent) => {
      if (menuVisibilityRef.current && !event.relatedTarget) {
        dismissMenu();
      }
    };

    window.addEventListener('blur', windowBlurListener);
    menuVisibilityRef.current = true;

    return () => {
      menuVisibilityRef.current = false;
      window.removeEventListener('blur', windowBlurListener);
    };
    // TODO: review for possible missing hook deps or document rationale for keeping eslint disable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
